import { SaleTargetReport } from "./SaleTargetReport";
import { UserTargetAlert } from "./UserTargetAlert";

export const TopView = () => {
    return (
        <div>
            <SaleTargetReport />
            <UserTargetAlert/>
        </div>
    );
}